(function(){
    'use strict';

    angular
        .module('elogbooks.user.my-details')
        .controller('UserMyDetailsInfoController', UserMyDetailsInfoController);

    UserMyDetailsInfoController.inject = [
        'userResponse',
        'apiClient',
        'confirmationModal',
        'messenger',
        'rootResourceResponse',
        '$state',
        'elbSettings'
    ];

    function UserMyDetailsInfoController(
        userResponse,
        apiClient,
        confirmationModal,
        messenger,
        rootResourceResponse,
        elbSettings
    ) {
        const vm = this;

        vm.user = userResponse;
        vm.telephoneList = [];
        vm.emailVerificationEnabled = elbSettings.getSetting('email_verification_enabled').value;
        vm.showEmailVerified = (
            vm.emailVerificationEnabled &&
            vm.user.emailVerified &&
            !(vm.user.category && vm.user.category === 'api_user')
        );
        vm.showEmailUnverified = (
            vm.emailVerificationEnabled &&
            !vm.user.emailVerified &&
            !(vm.user.category && vm.user.category === 'api_user')
        );

        vm.resetPasswordRequest = resetPasswordRequest;

        vm.telephoneList = vm.user.contactInformation?.fields?.filter(function(field) {
            return field.type === 'telephone';
        }) || [];

        function resetPasswordRequest() {
            return confirmationModal.open({primaryClass: 'btn-success'}).result.then(
                function () {
                    apiClient.create(rootResourceResponse.getLink('passwordchangerequests'), {
                        username: vm.user.username
                    }).then(function (response) {
                        if (response) {
                            messenger.success('PASSWORD_RESET_REQUEST_SUCCESSFUL');
                        } else {
                            messenger.success('REQUEST_ERROR');
                        }
                    });
                }
            );
        }
    }
})();